import { Footer } from "antd/es/layout/layout";
import React from "react";
import logo from "../Image/logo.png";
import "./style.css";
import { useTranslation } from "react-i18next";

const RemitClickInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="signUpLeftSec">
      <img src={logo} alt="logo" className="logo" />
      <div style={{ padding: "2rem 5rem" }}>
        <p className="remitclickInfo">
          {/* {t("remitclickInfo.info")} */}
          To facilitate your transaction on BajCan. Please sign up or login to
          your account. We value your privacy! All your user data is kept safe,
          secure and never shared.
        </p>
      </div>
    </div>
  );
};

export default RemitClickInfo;
